const getPhotosWithUrls = (photos, username, chatId) => {
  const res = [];
  const domain = 'http://t1m.bit.team';

  // eslint-disable-next-line array-callback-return
  photos.map((photo) => {
    res.push({
      origin: `${domain}/chat/${username}/${chatId}/${photo.origin}`,
      thumb: `${domain}/chat/${username}/${chatId}/${photo.thumb}`,
    });
  });

  return res;
};

export default getPhotosWithUrls;
